import React from 'react'
import { Collapse } from 'antd'
import { useTranslation } from 'react-i18next'
import { PageSection } from '../../../../shared/ui/PageSection'

type DetailItem = { key: string; label: string; content: string }

export const DetailsSection: React.FC = () => {
    const { t } = useTranslation()
    const items = t('details.items', { returnObjects: true }) as DetailItem[]

    return (
        <PageSection
            title={t('details.title')}
            align="start"
            style={{ backgroundColor: 'var(--bg-muted)' }}
        >
            <Collapse
                size="large"
                ghost
                items={items.map((it) => ({
                    key: it.key,
                    label: it.label,
                    children: (
                        <div style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>
                            {it.content}
                        </div>
                    )
                }))}
            />
        </PageSection>
    )
}

export default DetailsSection

